import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import { useCallback, useState } from 'react';
import { CountdownTimerDisplay } from '../components/countdownTimer/countdownTimerDisplay';
const CountdownTimerExample = ({ label, numSeconds, digitWidth }) => {
    const [endTimestampMs, setEndTimestampMs] = useState(performance.now() + numSeconds * 1000);
    const onClickReset = useCallback(() => {
        setEndTimestampMs(performance.now() + 3000);
    }, []);
    const onTimerEnd = useCallback(() => {
        console.log(`timer ended: ${label}`);
    }, [label]);
    return (_jsxs("div", { css: css `
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 10px;
        padding: 5px;
        margin: 5px;
      `, children: [_jsx("div", { children: label }), _jsx(CountdownTimerDisplay, { endTimestampMs: endTimestampMs, onTimerEnd: onTimerEnd, digitWidth: digitWidth }), _jsx(Button, { onClick: onClickReset, variant: 'contained', children: "Reset" })] }));
};
export const DevToolsCountdownTimerPage = () => {
    return (_jsxs(_Fragment, { children: [_jsx(CountdownTimerExample, { label: 'positive-secs', numSeconds: 3 }), _jsx(CountdownTimerExample, { label: 'fixed-width', numSeconds: 3, digitWidth: 10 }), _jsx(CountdownTimerExample, { label: 'zero-secs', numSeconds: 0 }), _jsx(CountdownTimerExample, { label: 'negative-secs', numSeconds: -5 })] }));
};
